import {FrontendHome} from 'components/Frontend/Home';

export const title = '首頁';

export const orderNum = 0;

export default FrontendHome;
